var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-card-content" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "10", lg: "8" } },
            [
              _c("app-label", {
                attrs: { label: "Dossier Name", value: _vm.value.name },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "10", lg: "8" } },
            [
              _c("app-label", {
                attrs: { value: _vm.value.vatNumber, label: "Vat Number" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "8", md: "6", lg: "6" } },
            [
              _c("app-label", {
                attrs: { value: _vm.value.streetName, label: "Address" },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "4", md: "4", lg: "2" } },
            [
              _c("app-label", {
                attrs: { value: _vm.value.streetNumber, label: "nr." },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "8", md: "6", lg: "6" } },
            [
              _c("app-label", {
                attrs: { value: _vm.value.cityName, label: "City" },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "4", md: "4", lg: "2" } },
            [
              _c("app-label", {
                attrs: { value: _vm.value.postalCode, label: "Postal Code" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "10", lg: "8" } },
            [
              _c("app-label", {
                attrs: { value: _vm.value.countryCode, label: "Country Code" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "10", lg: "8" } },
            [
              _c("app-label", {
                attrs: { value: _vm.value.phone, label: "Phone Number" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "10", lg: "8" } },
            [
              _c("app-label", {
                attrs: { value: _vm.value.email, label: "Email" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }